import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { WebApiService } from '../service/web-api.service';
import { environment } from '../../environments/environment';

@Injectable()
export class SignInService {

  constructor(private webApiServece: WebApiService) { }

  /**
   * ログイン
   * @param userId ユーザ名
   * @param password パスワード
   */
  execAuthenticate(userId: string, password: string): Observable<any[]> {
    const requestParam = { 'user_id': userId, 'password': password};
    return this.webApiServece.callAjaxPost(environment.apiServerBaseUrl + '/authorization/authenticate', requestParam)
      .map(cfResponse => {
        const data = cfResponse.data;
        // NGの場合はメッセージ、正常の場合はnullを返却
        if (! data.result) {
          return data.messages;
        }
        return null;
      })
      .catch(error => {
          return Observable.throw(error);
      });
  }
}
